import { InstrumentIcon } from '@foundation/apis/payments';
import cn from 'clsx';

import { AmericanExpress } from './PaymentIcons/AmericanExpress';
import { ApplePay } from './PaymentIcons/ApplePay';
import { Bancontact } from './PaymentIcons/Bancontact';
import { BankTransfer } from './PaymentIcons/BankTransfer';
import { Delivery } from './PaymentIcons/Delivery';
import { DenizBank } from './PaymentIcons/DenizBank';
import { DinnersClubInt } from './PaymentIcons/DinnersClubInt';
import { DirectDebit } from './PaymentIcons/DirectDebit';
import { DirectDebitPostFinance } from './PaymentIcons/DirectDebitPostFinance';
import { Discover } from './PaymentIcons/Discover';
import { ECommerceConnect } from './PaymentIcons/ECommerceConnect';
import { Elo } from './PaymentIcons/Elo';
import { GenericCard } from './PaymentIcons/GenericCard';
import { GooglePay } from './PaymentIcons/GooglePay';
import { Ideal } from './PaymentIcons/Ideal';
import { JCB } from './PaymentIcons/JCB';
import { Klarna } from './PaymentIcons/Klarna';
import { Maestro } from './PaymentIcons/Maestro';
import { MasterCard } from './PaymentIcons/MasterCard';
import { NuveiTwint } from './PaymentIcons/NuveiTwint';
import { OnlinePayment } from './PaymentIcons/OnlinePayment';
import { PayPal } from './PaymentIcons/PayPal';
import { SEPA } from './PaymentIcons/SEPA';
import { SubsidiaryPay } from './PaymentIcons/SubsidiaryPay';
import { TransbankWebpay } from './PaymentIcons/TransbankWebpay';
import { UnionPay } from './PaymentIcons/UnionPay';
import { Visa } from './PaymentIcons/Visa';
import { VisaTranslucent } from './PaymentIcons/VisaTranslucent';
import { Yookassa } from './PaymentIcons/Yookassa';

interface PaymentBrandIconProps {
  readonly icon: InstrumentIcon;
  readonly extraClassName?: string;
  readonly bgColor?: 'default' | 'transparent';
}

const styles = {
  default: `w-16 h-auto aspect-video self-center border rounded border-silver-700`,
  gpay: `w-16 h-auto aspect-video self-center`,
  paypal: `w-16 h-auto p-[5px] aspect-video self-center border rounded border-silver-700`,
};

export function PaymentIcon({
  icon,
  extraClassName,
  bgColor = 'default',
}: PaymentBrandIconProps) {
  switch (icon) {
    case InstrumentIcon.Amex:
      return AmericanExpress(cn(styles.default, extraClassName));
    case InstrumentIcon.Diners:
      return DinnersClubInt(cn(styles.default, extraClassName));
    case InstrumentIcon.Discover:
      return Discover(cn(styles.default, extraClassName));
    case InstrumentIcon.Elo:
      return Elo(cn(styles.default, extraClassName));
    case InstrumentIcon.Jcb:
      return JCB(cn(styles.default, extraClassName));
    case InstrumentIcon.MasterCard:
      return MasterCard(cn(styles.default, extraClassName));
    case InstrumentIcon.Maestro:
      return Maestro(cn(styles.default, extraClassName));
    case InstrumentIcon.UnionPay:
      return UnionPay(cn(styles.default, extraClassName));
    case InstrumentIcon.Visa:
      return bgColor !== 'transparent'
        ? Visa(cn(styles.default, extraClassName))
        : VisaTranslucent(cn(styles.default, extraClassName));
    case InstrumentIcon.PayPal:
      return PayPal(cn(styles.paypal, extraClassName));
    case InstrumentIcon.DirectDebit:
      return DirectDebit(cn(styles.default, extraClassName));
    case InstrumentIcon.TransbankWebpay:
      return TransbankWebpay(cn(styles.default, extraClassName));
    case InstrumentIcon.Subsidiary:
      return SubsidiaryPay(cn(styles.default, extraClassName));
    case InstrumentIcon.GenericCard:
      return GenericCard(cn(styles.default, extraClassName));
    case InstrumentIcon.Ideal:
      return Ideal(cn(styles.default, extraClassName));
    case InstrumentIcon.Bancontact:
      return Bancontact(cn(styles.default, extraClassName));
    case InstrumentIcon.ApplePay:
      return ApplePay(cn(styles.default, extraClassName));
    case InstrumentIcon.GooglePay:
      return GooglePay(cn(styles.gpay, extraClassName));
    case InstrumentIcon.ECommerceConnect:
      return ECommerceConnect(cn(styles.default, extraClassName));
    case InstrumentIcon.NuveiTwint:
      return NuveiTwint(cn(styles.default, extraClassName));
    case InstrumentIcon.SEPA:
      return SEPA(cn(styles.default, extraClassName));
    case InstrumentIcon.Delivery:
      return Delivery(cn(styles.default, extraClassName));
    case InstrumentIcon.OnlinePayment:
      return OnlinePayment(cn(styles.default, extraClassName));
    case InstrumentIcon.BankTransfer:
      return BankTransfer(cn(styles.default, extraClassName));
    case InstrumentIcon.Yookassa:
      return Yookassa(cn(styles.default, extraClassName));
    case InstrumentIcon.DirectDebitPostFinance:
      return DirectDebitPostFinance(cn(styles.default, extraClassName));
    case InstrumentIcon.DenizBank:
      return DenizBank(cn(styles.default, extraClassName));
    case InstrumentIcon.PayByInvoice:
      return SubsidiaryPay(cn(styles.default, extraClassName));
    case InstrumentIcon.Klarna:
      return Klarna(cn(styles.default, extraClassName));
  }
}
